import { MDXProvider } from "@mdx-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { CodeBlock } from "./components/CodeBlock";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found in document");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <MDXProvider components={{ pre: CodeBlock }}>
        <App />
      </MDXProvider>
    </BrowserRouter>
  </StrictMode>,
);
